import styled from "styled-components";
import { colors } from "../utils/Colors";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const NavBar = () => {
  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language.startsWith("fr") ? "en" : "fr");
  };

  const handleNavClick = () => setShow(false);

  return (
    <MainContainer collapseOnSelect expand="lg" className="bg-body-tertiary">
      <ContainerNav className="m-0 p-0">
        <Navbar.Brand>
          <p
            style={{
              cursor: "default",
              color: colors.primary200,
              fontWeight: "bold",
              fontSize: "24px",
            }}
          >
            <span style={{ color: colors.primary100 }}>{`<`}</span>/F
            <span style={{ color: colors.primary100 }}>{`>`}</span>
          </p>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          style={{ border: `2px solid ${colors.primary100}` }}
          onClick={() => setShow(!show)}
        />
        {show && <Backdrop onClick={handleNavClick} />}
        <NavHamburgerContainer $show={show}>
          <ContainerLinkIcon>
            <Nav className="me-auto w-100">
              <ContainerLink className="d-flex w-100 justify-content-center align-items-center">
                <Link
                  style={{ margin: "0 1rem 0 0" }}
                  href="#about"
                  active={false}
                  onClick={handleNavClick}
                >
                  {t("nav.about")}
                </Link>
                <Link href="#skills" active={false} onClick={handleNavClick}>
                  {t("nav.skills")}
                </Link>
                <Link href="#projects " active={false} onClick={handleNavClick}>
                  {t("nav.projects")}
                </Link>
                <Link href="#contact" active={false} onClick={handleNavClick}>
                  {t("nav.contact")}
                </Link>
              </ContainerLink>
            </Nav>
            <ContainerIcon>
              <LangToggle onClick={toggleLanguage}>
                {i18n.language.startsWith("fr") ? "EN" : "FR"}
              </LangToggle>
            </ContainerIcon>
          </ContainerLinkIcon>
        </NavHamburgerContainer>
      </ContainerNav>
    </MainContainer>
  );
};

export default NavBar;

const MainContainer = styled(Navbar)`
  padding-top: 1rem;
  display: flex;
  justify-content: center;
  height: 4rem;

  background-color: ${colors.white} !important;
`;

const ContainerNav = styled(Container)`
  width: 70%;

  @media (max-width: 1150px) {
    width: 80%;
  }
`;

const ContainerLink = styled.div`
  @media (max-width: 992px) {
    justify-content: baseline !important;
    align-items: baseline !important;
    flex-direction: column;
    gap: 2rem;
  }
`;

const Link = styled(Nav.Link)`
  all: unset;
  color: hsla(197, 10%, 50%, 1);
  font-size: 24px;
  font-weight: 700;
  transition: color 0.3s;

  &:hover {
    cursor: pointer;
    color: ${colors.primary};
  }

  &::before,
  &::after {
    display: inline-block;
    opacity: 0;
    -webkit-transition:
      -webkit-transform 0.3s,
      opacity 0.2s;
    -moz-transition:
      -moz-transform 0.3s,
      opacity 0.2s;
    transition:
      transform 0.3s,
      opacity 0.2s;
  }

  &::before {
    margin-right: 2px;
    content: "<";
    -webkit-transform: translateX(20px);
    -moz-transform: translateX(20px);
    transform: translateX(20px);
  }

  &::after {
    margin-left: 2px;
    content: ">";
    -webkit-transform: translateX(-20px);
    -moz-transform: translateX(-20px);
    transform: translateX(-20px);
  }

  &:hover::before,
  &:hover::after,
  &:focus::before,
  &:focus::after {
    opacity: 1;
    -webkit-transform: translateX(0px);
    -moz-transform: translateX(0px);
    transform: translateX(0px);
  }

  @media (max-width: 992px) {
    color: ${colors.primary400};
    font-size: 34px;
    margin: 0 1rem;
  }

  @media (max-width: 550px) {
    font-size: 24px;
  }
`;

const NavHamburgerContainer = styled.div`
  display: flex;
  flex: 1;
  @media (max-width: 992px) {
    flex: unset;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: fit-content;

    padding: 1rem;
    background-color: ${colors.primary100};
    border-radius: 0 55px 55px 0;
    padding-top: 4rem;
    flex-direction: column;
    z-index: 1050;
    transform: ${({ $show }) =>
      $show ? "translateX(0)" : "translateX(-100%)"};
    transition: transform 0.3s ease-in-out;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1040;
`;

const LangToggle = styled.button`
  all: unset;
  color: hsla(197, 10%, 50%, 1);
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  padding: 0.2rem 0.5rem;
  border: 2px solid hsla(197, 10%, 50%, 1);
  border-radius: 8px;
  transition: all 0.3s;
  margin-right: 0.5rem;
  width: 30px;
  height: 30px;
  text-align: center;

  &:hover {
    color: ${colors.primary};
    border-color: ${colors.primary};
  }

  @media (max-width: 992px) {
    color: ${colors.primary400};
    border-color: ${colors.primary400};
    font-size: 22px;
  }
`;

const ContainerIcon = styled(Nav)`
  @media (max-width: 992px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    margin-top: 4rem;
  }
`;

const ContainerLinkIcon = styled.div`
  display: flex;
  flex: 1;
  @media (max-width: 992px) {
    display: block;
    flex: unset;
  }
`;
